module.exports = __webpack_public_path__ + "img/404.2bc179b.png";